<template>
  <div class="things-list-container">
    <cube-scroll  direction="horizontal"  ref="scroll" :data="tagList" class="horizontal-scroll-list-wrap" v-if="type === 'me'">
      <div class="tag-list"><span :class="['filter-tag-item', activeText == item ? 'active' : '']" v-for="item in tagList" :key=" item + 'tag'" @click.stop="activeText = item">{{item}}</span></div>
    </cube-scroll>
    <template v-for="(item, index) in listData">
      <template v-if="item.infos.filter(item=> activeText === '全部' || item.step_type === activeText || (item.step_type && item.step_type.includes(activeText))).length > 0">
        <div :key="index" class="things-item flex-column things-item-el">
          <span class="date-title" :id="item.date">{{ item.date.replace(/-/g, '.') }}</span>
          <template v-for="(value, i) in item.infos">
            <template v-if="(activeText === '全部' || value.step_type === activeText || (value.step_type && value.step_type.includes(activeText)))">
              <div :key="i" class="things-child-item flex-start"
              :class="[value.finished === 0 ? 'things-give-up' : value.finished === 1 ? 'thing-complete' : '']"
              @click="toCampusDetail(value)">
              <i class="iconfont" v-if="value.type === 'personal'"
                :class="[value.finished === 1 ? 'iconxuanzhong2' : 'iconweixuanzhong1', {'things-over': value.finished === 0}]"
                @click.stop="handleItemClick(value)"></i>
              <img class="company-logo" :src="value.company_logo || 'https://files.wondercv.com/icon/Artboard.png'"
                alt="">
              <div class="things-info">
                <div class="things-info-title flex-start">
                  <span v-if="value.company_name">{{ value.company_name }}</span>
                  <span v-if="value.step_type">{{ value.step_type }}</span>
                </div>
                <div class="things-info-time flex-start">
                  <span class="flex-center" v-if="value.execute_at">{{ value.execute_at | timeFilter('HH:mm') }}</span>
                  <span class="flex-center" v-else>网申开始</span>
                  <span class="flex-center address" v-if="value.address">{{ value.address }}</span>
                </div>
              </div>
            </div>
            </template>
          </template>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { componentsMixin } from '../../../assets/js/mixin/components'
import { envMixin } from '../../../assets/js/mixin/global'
export default {
  mixins: [envMixin, componentsMixin],
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'me'
    }
  },
  data () {
    return {
      tagList: ['全部', '网申', '笔试', '初面', '二面', '终面', 'offer'],
      activeText: '全部'
    }
  },
  components: {},
  computed: {},
  methods: {
    toCampusDetail (value) {
      const token = value.comp_recruit_info_token || value.token || 'empty_token'

      if (this.isWxMini) {
        this.$wechat.miniProgram.navigateTo({
          url: `/pages/campusOffersDetail/campusOffersDetail?campusOfferToken=${token}`
        })
      } else {
        this.$router.push({
          path: `/jobs/campus/offers/${token}`,
          query: {
            company_token: value.company_token,
            tab: 'me'
          }
        })
      }

      this.$db.ls.set('showNav', true)
    },
    handleItemClick (value) {
      if (value.finished === 2) {
        this.$api.campusOffers.updateCampusRecruitmentState(value.id, { finished: 1 }).then(res => {
          if (res.code === 1000) {
            value.finished = 1
            this.showToast('待办已完成')
          }
        }).catch(e => console.log(e))
      }
      if (value.finished === 1) {
        this.$api.campusOffers.updateCampusRecruitmentState(value.id, { finished: 2 }).then(res => {
          if (res.code === 1000) {
            value.finished = 2
          }
        }).catch(e => console.log(e))
      }
    }
  },
  watch:{
    type(value){
      if(value !== 'me'){
        this.activeText = '全部'
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../../assets/scss/global/variable';
@import '../../../assets/scss/global/mixin';
.things-list-container {
  padding: 0 16px;
  .horizontal-scroll-list-wrap{
    border-radius: 5px;
    margin: 16px -16px 20px;
    padding-left: 16px;
    ::v-deep .cube-scroll-content{
      display: inline-block;
    }
    .tag-list{
      white-space: nowrap;
      .filter-tag-item{
        border-radius: 6px;
        padding: 5px 12px;
        font-size: 14px;
        font-weight: 400;
        color: #9C9C9C;
        margin-right: 4px;
        word-break: normal;
        display: inline-block;
        background: #fff;
        &.active{
          background: #FF6644;
          color: #fff;
        }
      }
    }
  }



  .things-item {
    margin-bottom: 6px;
    &:last-child {
      margin-bottom: 18px;
    }
    &:first-child {
      margin-top: 4px;
    }
    .date-title {
      margin-bottom: 14px;
      color: $color-title;
      font-weight: 500;
      margin-top: 14px;
    }
    .things-child-item {
      margin-bottom: 8px;
      padding: 16px 18px;
      background-color: $color-light;
      border-radius: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      .iconfont {
        // background-color: #121212;
        margin-right: 18px;
        font-size: 20px;
        color: #ececec;
        border-radius: 6px;
      }
      .iconxuanzhong2 {
        color: #cfcfcf;
      }
      .company-logo {
        width: 46px;
        height: 46px;
        border-radius: 4px;
        margin-right: 16px;
        object-fit: contain;
        border: 1px solid #F4F4F4;
      }
      .things-info {
        .things-info-title {
          color: $color-title;
          font-size: $font-size-medium-x;
          margin-bottom: 10px;
          span:first-child {
            display: inline-block;
            margin-right: 4px;
            @include ellipsis(160px);
          }
        }
        .things-info-time {
          color: #9c9c9c;
          .divider {
            width: 16px;
            text-align: center;
          }
          .address::before {
            content: '';
            display: inline-block;
            width: 1px;
            height: 12px;
            background-color: #9c9c9c;
            margin: 0 6px;
          }
        }
      }
    }
    .things-give-up {
      span {
        color: #9c9c9c;
      }
      .things-info {
        .things-info-title {
          text-decoration: line-through;
          text-decoration-color: #9c9c9c;
        }
      }
      .things-info-time {
        position: relative;
        text-decoration: line-through;
        text-decoration-color: #9c9c9c;
        // &::after {
        //   display: inline-block;
        //   content: '';
        //   width: max-content;
        //   height: 1px;
        //   background-color: #9c9c9c;
        //   position: absolute;
        //   top: 50%;
        //   transform: translateY(-50%);
        // }
      }
    }
    .thing-complete {
      .things-info-title {
        color: #9c9c9c;
      }
    }
    .things-over {
      background-color: #f9f9f9;
    }
  }
}
</style>
